module.exports = __webpack_public_path__ + "static/media/health.d72998c3.jpg";